
import { defineComponent, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    content: {
      type: Object,
      required: true
    },
    current: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const router = useRouter()
    const route = useRoute()
    const i18n = useI18n()

    return {
      filename: computed(() => {
        const lang = i18n.locale.value as 'ja' | 'en'
        const contents = props.content.contents
        if (!contents) return ''
        if (contents.name && (contents.name.ja || contents.name.en)) {
          // 例）langがenのとき、name[en]がemptyならname[ja]が表示される
          return contents.name?.[lang] || contents.name?.ja || contents.name?.en
        }
        return props.content.contents.originalFileName || ''
      }),
      onClick: () => {
        // アイテム内遷移はヒストリーに残さずに遷移する
        router.replace({
          params: {
            bundleIndex: route.params.bundleIndex ? route.params.bundleIndex : '1',
            contentIndex: props.content.id
          }
        })
      }
    }
  }
})
